export const APP_THEME_DARK = 'dark';
export const APP_THEME_LIGHT = 'light';
export const DEFAULT_THEME = APP_THEME_DARK;
